/**
 * THOR product-card quick add — adds first/default available variant via /cart/add.js
 */
(() => {
  if (window.thorQuickAdd) return;

  const toast = () => window.thorToast || window.toast;

  const updateCartCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartRes = await fetch(`${root}cart.js`);
      const cart = await cartRes.json();
      const cartLink = document.querySelector('.site-header__icon[aria-label="Cart"]');
      if (!cartLink) return;
      let count = cartLink.querySelector('sup');
      if (cart.item_count > 0) {
        if (!count) {
          count = document.createElement('sup');
          cartLink.appendChild(count);
        }
        count.textContent = String(cart.item_count);
      } else if (count) {
        count.remove();
      }
    } catch (_) {}
  };

  const addVariant = async (btn) => {
    const variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    const loadingId = toast()?.loading?.('Adding to bag…');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');

      toast()?.success?.(
        `${data.product_title || 'Item'} added to bag`,
        loadingId ? { id: loadingId } : undefined
      );
      await updateCartCount();
    } catch (err) {
      toast()?.error?.(err.message || 'Could not add to cart', loadingId ? { id: loadingId } : undefined);
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-product-quick-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    addVariant(btn);
  });

  window.thorQuickAdd = { addVariant };
})();
